import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { bank, BankManipulationViewModel } from "./bankManipulation-viewModel"

export class BankManipulationView extends View<BankManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-D92E77B7-CBBE-4DD0-B822-0A668EDFE41A"
    }
    loadHtml(): string {
        let element = require('./bankManipulation.html').default;
        let style = require('./bankManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set banks(v: ObservableArray<bank>) { this._banks = v; } public get banks(): ObservableArray<bank> { return this._banks;} private _banks: ObservableArray<bank>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestBankCreation(){
        this.dataContext.requestBankCreation();
    }
}
